module.exports = __webpack_public_path__ + "img/br20.c9c2e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br20.jpg
// module id = MEGb
// module chunks = 0